
import { Icon } from '@iconify/react';

interface ButtonProps{
    text:string,
    redirect?:string,
    // variant: 'yellow' | 'gray'
    onClick?: ()=> void
}

const CustomButton =({text, redirect, onClick}:ButtonProps)=>{
    // const bgColor = variant === 'yellow' ? 'bg-[#FBE64B]' : 'bg-white/80'

    const handleClick = () => {
        if (redirect) {
            window.open(redirect, '_blank');
        } else if (onClick) {
            onClick();
        }
    };

    return(
        <div onClick={handleClick} className={`flex p-2 gap-4 font-family-open-sans rounded-full w-fit items-center bg-[#222] cursor-pointer border border-2 shadow-sm`}>
            <p className="text-[18px] font-bold pl-4 m-0 text-[#FFF]">{text}</p>
           <div className="bg-[#FBE64B] rounded-full w-9 h-9 flex items-center justify-center">
                <Icon icon="ph:arrow-line-up-right" fontSize={20} color="#222" />
            </div>
        </div>
    )
}

export default CustomButton
